import styled, { css } from "styled-components";
import { BREAKPOINTS } from "../../variables/Breakpoints";
import { setFlex, setPosition } from "../../variables/Position";
import { COLOURS } from "../../variables/Colors";

const setBreakSize = size => {
  switch (size) {
    case "small":
      return css`
        height: 15px;
      `;
    case "medium":
      return css`
        height: 30px;
      `;
    case "large":
      return css`
        height: 50px;
      `;
    default:
      return css``;
  }
};

export const VideoBackground = styled.div`
  ${setPosition({ position: "fixed" })};
  height: 100%;
  width: 100%;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    image-rendering: pixelated;
  }
`;

export const AppWrapper = styled.div`
  background-color: ${COLOURS.primary.black};
  height: auto;
  width: 100%;
  overflow-x: hidden;
`;

export const LandingWrapper = styled.div`
  ${setPosition({ position: "relative" })};
`;

export const Wrapper = styled.div`
  ${setPosition({ position: "relative" })};
  min-height: ${props => props.$height || "auto"};
  ${props =>
    props.$margin &&
    `
    margin: 0 3rem;
    @media (max-width: ${BREAKPOINTS.sm}px) {
      margin: 0 2rem;
    }
  `};
`;

export const Container = styled.div`
  ${setPosition({ position: "relative" })};
  ${props => props.$index && `z-index: ${props.$index}`};
  ${props => props.$absolute && "position: absolute"};
  ${props =>
    props.$flex &&
    setFlex({
      justify: props.$justify,
      align: "center",
      direction: "column",
    })};
  min-height: ${props => props.$height || "200vh"};
  width: 100%;
  &.scale {
    @media (max-width: ${BREAKPOINTS.sm}px) {
      min-height: auto;
    }
  }
`;

export const SceneContainer = styled.div`
  ${setPosition({ position: "relative" })};
  width: 100%;
  height: 100%;
  max-height: 100vh;
`;

export const Scene = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export const SceneChildren = styled.div`
  ${setPosition({ position: "absolute", top: "0", left: "0", zIndex: 10 })};
  height: 100%;
  width: 100%;
  max-height: 100vh;
  overflow: hidden;
`;

export const Break = styled.div`
  ${props => setBreakSize(props.$size)};
  display: ${props => (props.$mobile ? "none" : "block")};

  @media (max-width: ${BREAKPOINTS.sm}px) {
    display: ${props => (props.$desktop ? "none" : "block")};
  }
`;

export const IframeContainer = styled.div`
  background-color: ${props => props.$background || COLOURS.primary.white};
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  iframe {
    overflow: hidden;
    body {
      overflow: hidden;
    }
  }
`;

export const ImageContainer = styled.div`
  ${setFlex({ justify: "center", align: "center" })};
  min-width: fit-content;
  height: fit-content;
  ${props => props.$margin && "margin-bottom: 3rem"};
`;

export const Image = styled.img`
  width: auto;
  max-width: 100%;
  ${props =>
    props.$small &&
    `
    max-height: 20px;
  `};
`;
